<template>
    <div class="labeled-select">
        <DeliverableLabel v-if="label" :color="labelColor" :label="label" />
        <Select
            :model-value="modelValue"
            class="hox-select-dark"
            size="small"
            :placeholder="placeholder"
            @onChange="onChange"
        >
            <Option v-for="option in options" :key="option.value" :value="option.value">{{ option.label }}</Option>
        </Select>
    </div>
</template>

<script lang="ts">
import DeliverableLabel from "@/components/Campaign/DeliverableLabel.vue";
import { EditableEvent } from "@/enums/editables";
import type { PropType } from "vue";

export default {
    name: "LabeledSelect",
    components: { DeliverableLabel },
    props: {
        label: { type: String, default: "" },
        labelColor: {
            type: String as PropType<"default" | "primary">,
            default: "default"
        },

        options: {
            type: Array as PropType<{ label: string; value: string }[]>,
            required: true
        },
        placeholder: {
            type: String,
            default: "Select"
        },

        // eslint-disable-next-line vue/require-prop-types
        modelValue: {
            required: true
        }
    },

    emits: [EditableEvent.Update],

    methods: {
        onChange(value: string) {
            this.$emit(EditableEvent.Update, value);
        }
    }
};
</script>

<style lang="scss">
.labeled-select {
    display: flex;
    flex: 1 0;
    justify-content: flex-start;
    align-items: center;
    width: 100%;

    &__tag {
        flex: 0 0 80px;
    }

    &__text {
        flex: 1 0;
        display: flex;
        overflow: hidden;
        padding: 0 5px;
        align-items: center;
    }
}
</style>
